"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Validator = function () {
  function Validator(value) {
    (0, _classCallCheck3.default)(this, Validator);

    this.value = value;
    this.errors = [];
    this.type = null;
  }

  (0, _createClass3.default)(Validator, [{
    key: "string",
    value: function string() {
      if (typeof this.value !== "string") {
        this.errors.push("Value must be a string.");
      }
      return this;
    }
  }, {
    key: "number",
    value: function number() {
      if (typeof Number(this.value) !== "number") {
        this.errors.push("Value must be a number.");
      }
      return this;
    }
  }, {
    key: "date",
    value: function date() {
      if (!(this.value instanceof Date) || isNaN(this.value.getTime())) {
        this.errors.push("Value must be a valid date.");
      }
      return this;
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "This field is required.";

      if (this.value === undefined || this.value === null || this.value === "") {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "maxLength",
    value: function maxLength(max) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be " + max + " characters or less.";

      if (this.type === "string" && this.value.length > max) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "minLength",
    value: function minLength(min) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be at least " + min + " characters.";

      if (this.type === "string" && this.value.length < min) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "min",
    value: function min(_min) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be at least " + _min + ".";

      if (this.type === "number" && this.value < _min) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "max",
    value: function max(_max) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be " + _max + " or less.";

      if (this.type === "number" && this.value > _max) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "isBefore",
    value: function isBefore(date) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Date must be before the specified date.";

      if (this.type === "date" && this.value >= date) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "isAfter",
    value: function isAfter(date) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Date must be after the specified date.";

      if (this.type === "date" && this.value <= date) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "matchesRegex",
    value: function matchesRegex(regex) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Invalid format.";

      if (this.type === "string" && !regex.test(this.value)) {
        this.errors.push(errorMessage);
      }
      return this;
    }
  }, {
    key: "isEmail",
    value: function isEmail() {
      var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Invalid email format.";

      if (this.type === "string") {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.value)) {
          this.errors.push(errorMessage);
        }
      }
      return this;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.errors.length === 0;
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      return this.errors;
    }
  }, {
    key: "getError",
    value: function getError() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return this.errors[index] || null;
    }
  }], [{
    key: "string",
    value: function string(value) {
      var validator = new Validator(value);
      validator.type = "string";
      return validator.string();
    }
  }, {
    key: "number",
    value: function number(value) {
      var validator = new Validator(value);
      validator.type = "number";
      return validator.number();
    }
  }, {
    key: "date",
    value: function date(value) {
      var validator = new Validator(value);
      validator.type = "date";
      return validator.date();
    }
  }]);
  return Validator;
}();

exports.default = Validator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/validator.js
// module id = 2916
// module chunks = 0